/* eslint-disable import/prefer-default-export */

import { GET_COURSES_REQUEST, GET_COURSES_SUCCESS, GET_COURSES_FAIL, RESET_COURSES } from '../constants';
import { buildQuery } from '../helpers';
export function getCourses() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    page: 1,
    perPage: 32,
    sort: '-publishedUpdatedDate',
    search: ''
  };
  var doNotAppend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var query = buildQuery(params);
  return {
    types: [GET_COURSES_REQUEST, GET_COURSES_SUCCESS, GET_COURSES_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/courses/with-related-lessons?".concat(query), {
        method: 'GET'
      });
    },
    doNotAppend: doNotAppend
  };
}
export function reset() {
  return {
    type: RESET_COURSES
  };
}